import React, { useEffect, useState } from 'react'

function DeleteTask(props) {
  const [getDeleteTask, setDeleteTask] = useState([]);

  useEffect(() => {
    setDeleteTask(props.TaskData);
  }, [props.TaskData])
  return (
    <>
      <div className="text-left px-2 pb-0">
        <p>
          <h6>Following Task will be deleted and could not be recovered!!</h6>
          <ul>
            <li><b>Task Key :</b> {getDeleteTask.TaskKey}</li>
          </ul>
        </p>
      </div>
      <div id="DeleteTaskDetails" hidden>{JSON.stringify(getDeleteTask)}</div>
    </>
  )
}

export default DeleteTask;